import produce from "immer";
import { TaskVehicleActions } from ".";
import { IStoreState } from "../../initialStoreState";
import { initialTaskVehicleState } from "./taskVehicle.types";
import { LoadState } from "../../../constants/enums";
import { FETCH_ADD_VEHICLE_FAILED, FETCH_ADD_VEHICLE_PROGRESS, FETCH_ADD_VEHICLE_SUCCESS } from "./taskVehicleActions";

export const taskVehicleReducer = (
    state: IStoreState["tasks"]["vehicle"] = initialTaskVehicleState,
    action: TaskVehicleActions
  ) => {
    switch (action.type) {
        case FETCH_ADD_VEHICLE_PROGRESS: {
            const newState = produce(state, draftState=>{
                draftState.addVehicle.loading = LoadState.InProgress;
                draftState.addVehicle = initialTaskVehicleState['addVehicle'];
            })
            return newState;
        }
        case FETCH_ADD_VEHICLE_SUCCESS: {
            const {data} = action.payload;
            const newState = produce(state, draftState=>{
                draftState.addVehicle.loading = LoadState.Loaded;
                draftState.addVehicle.data = data;
            })
            return newState;
        }
        case FETCH_ADD_VEHICLE_FAILED: {
            const newState = produce(state, draftState=>{
                draftState.addVehicle.loading = LoadState.Failed;
            })
            return newState;
        }
        
        default:
            return state;
    }
  }